import React from 'react';

import { updateBreadcrumbs } from '~src/spacesPlatform/actions/UpdateBreadcrumbsAction';
import { BreadcrumbStateInfo } from '~src/spacesPlatform/components/breadcrumbs/BreadcrumbStateInfo';
import { ConnectedSpaceInfoProvider } from '~src/spacesPlatform/components/Explorer/helpers/SpaceInfoProvider';
import { SpacesSiteUrls } from '~src/spacesPlatform/components/spaceComponents/SpacesSiteUrls';
import { SpaceInfo, SpaceItemForNonEntitySpace } from '~src/spacesPlatform/state/SpaceInfo';

import { getAppStore } from '../../../../bootstrap/redux/store/AppStore';
import { ConnectedQueryParamUpdateProvider } from '../../../../bootstrap/routerHelpers/QueryParamUpdateProvider';
import { Messages } from '../../../../codegen/Localize';
import { ConnectedAllGroupSetsSpace } from './ConnectedAllGroupSetsSpace';

export interface AllGroupSetsSpaceProviderProps {
  readonly siteName: string;
  readonly routeLocationPath: string;
  readonly routeLocationSearch: string;
  readonly urls: SpacesSiteUrls;
}

const groupSetsSpaceInfo: SpaceInfo = { spaceType: 'groupsets', subspaceName: undefined, item: SpaceItemForNonEntitySpace };

export const AllGroupSetsSpaceProvider: React.FunctionComponent<AllGroupSetsSpaceProviderProps> = (props) => {

  React.useEffect(
    () => {
      getAppStore().dispatch(updateBreadcrumbs([getGroupSetsPlaceBreadcrumb(props.urls)]));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  return (
    <ConnectedSpaceInfoProvider spaceInfo={groupSetsSpaceInfo}>
      <ConnectedQueryParamUpdateProvider
        routeLocationPath={props.routeLocationPath}
        routeLocationSearch={props.routeLocationSearch}
        shouldUpdateBreadcrumbs={true}
        shouldUpdateContentTypes={false}
        shouldUpdateFilters={true}
        shouldUpdateSort={true}
      >
        { <ConnectedAllGroupSetsSpace
          siteName={props.siteName}
        /> }
      </ConnectedQueryParamUpdateProvider>
    </ConnectedSpaceInfoProvider>
  );
};

export function getGroupSetsPlaceBreadcrumb(urls: SpacesSiteUrls): BreadcrumbStateInfo {
  const href = urls.groupSetsUrl();
  return {
    id: href,
    text: Messages.allGroupSets(),
    href: href,
    testId: 'group-sets-link'
  };
}
